import { app } from '../../../../../app';
import { Controller } from './hard-token-importer-table.controller';

app.component('hardTokenImporterTable', {
    templateUrl: require('./hard-token-importer-table.html'),
    controller: Controller,
    bindings: {
        type: '<',
        otpType: '<',
        tokens: '<',
        onChange: '&'
    }
});



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-integration/hard-token-importer-table/hard-token-importer-table.component.js